// const _findIndex = require('../../utils/findIndex.js');
const _findIndex = require('lodash.findindex');
const Immutable = require('seamless-immutable');
const helper = require('@helper/dish-helper');
const commonHelper = require('@helper/common-helper');
const { filterNoneString } = commonHelper;
import { MaxOrderedDishCount, INDUSTRY, MemberPrivTypes } from '@helper/const';
import ReducerContainer from '@helper/reducer-helper';
// import { MemberPrivTypes } from '../../helper/const';
const reducerContainer = ReducerContainer.create();

module.exports = function(
  state = Immutable.from({
    industry: INDUSTRY.NORMAL,
    activeDishTypeId: -1,
    activeDishTypeIdIndex: 0,
    dishTypesData: [],
    dishesData: [],
    dishPageTpl: 'default',
    dishesDataDuplicate: [],
    enableMemberRegistry: false,
    shopInfo: {
      isOldMarketing: true, // true 老逻辑 false 新逻辑
      commercialName: '',
      openTimeList: [],
      diningForm: undefined,
      formatDishesData: {},
      marketList: {},
      marketListUpdate: [],
      marketMatchDishes: false,
      multiMarketing: [],
      limitedMarketing:[],
      notice: null,
      marketCoupon: null,
      couponSuccessInfo: null,
      couponSuccess: false,
      getMarket: false,
      mobile: 0,
      serviceMobile: 0,
      address: '',
      isEnableShop: true,
      choosePeopleCountFlag: false,
      isYaZuo: false,
      couponList: [],
      ruleId: null,
      planId: null,
      flag: null,
      type: null,
      payBeforeDinner: false,
      enableOpenDish: false,
    },
    dishDetailData: undefined,
    takeawayServiceProps: undefined,
    dishBoxChargeInfo: null,
    normalDiscountProps: null,
    discountProps: null,
    errorMessage: {},
    load: {
      status: false,
      word: '',
    },
    serviceStatus: {},
    callMsg: {
      info: '',
      callStatus: false,
    },
    callAble: true,
    shopLogo: '',
    orderPageImage: '',
    orderPageTitle: '',
    wmCartImageUrl: '',
    tsCartImageUrl: '',
    sendTimeList: [],
    isAcceptOrder: null,
    pageIsLoaded: false,
    soldTopDishList: [],
    dishDetailRecommendDishList: [],
    guidStatus: false,
    isDataInitOver: false,
    saveOrderChangeItem: null,
    deliveryTime: '--',
    changed: false,
    selfChooseDishList: [],
    selfChooseDishTypeObj: {},
  }),
  action,
) {
  const { type, payload } = action;
  let orderIdx;
  let newState;

  const getFirstValidDishTypeId = _payload => {
    const dishTypeList = _payload.dishTypeList || [];
    const dishList = _payload.dishList || [];
    let i = 0;
    while (i < dishTypeList.length) {
      const dishTypeDishes = dishList.filter(dish => dishTypeList[i].dishIds && dishTypeList[i].dishIds.indexOf(dish.id) > -1);
      const isNotEmpty = dishTypeDishes.some(dish => dish.currRemainTotal !== 0);
      if (isNotEmpty) return dishTypeList[i].id;
      i++;
    }
    return -1;
  };

  // 对标签中类进行排序
  const sortDishTypesWithTag = (prev, next) => prev.sort - next.sort;

  const getDishTypesWithTag = dishList => {
    const dishIdsWithTagTypes = {};
    const tagTypes = {};
    // 标签中类 list
    let tagTypeList = [];
    // 默认的六个标签中类
    const defaultTagTypeList = [];
    // 自定义的标签中类
    const customTagTypeList = [];
    const iconTagReg = /热门|推荐|折扣|赠品|特价|特色/;

    // 遍历 dishList
    // 找出所有的含有标签的菜品
    // 将这些菜品归类到相应的标签下
    dishList.forEach(dish => {
      if (Array.isArray(dish.dishPropertyTypeInfos) && dish.dishPropertyTypeInfos.length !== 0) {
        dish.dishPropertyTypeInfos.forEach(dishPropertyInfo => {
          if (dishPropertyInfo.type === 2) {
            dishPropertyInfo.properties.forEach(property => {
              if (!dishIdsWithTagTypes[property.name]) {
                dishIdsWithTagTypes[property.name] = [];
              }
              dishIdsWithTagTypes[property.name].push(dish.proxyDishId || dish.id);
              tagTypes[property.name] = {
                id: property.id,
                name: property.name,
                sort: property.sort,
                // 含有 type 属性并且值为 tag 的时候，表示标签中类
                type: 'tag',
                dishIds: dishIdsWithTagTypes[property.name].filter((item, index, array) => array.indexOf(item) === index),
              };
            });
          }
        });
      }
    });

    for (const key in tagTypes) {
      if (iconTagReg.test(tagTypes[key].name)) {
        defaultTagTypeList.push(tagTypes[key]);
      } else {
        customTagTypeList.push(tagTypes[key]);
      }
    }

    // 合并各种标签并对标签中的菜品进行去重
    tagTypeList = defaultTagTypeList.sort(sortDishTypesWithTag).concat(customTagTypeList.sort(sortDishTypesWithTag));

    return tagTypeList.filter(tagType => typeof tagType !== 'undefined' || (tagType && tagType.dishIds.length !== 0));
  };

  if (reducerContainer.exist(type)) {
    return reducerContainer.getNextState(type, state, payload);
  }

  switch (type) {
    case 'SET_INDUSTRY_INFO': {
      return state.set('industry', payload);
    }
    case 'SET_MENU_DATA': {
      const { dishList = [], dishTypeList = [] } = payload;
      // dishList.sort((a, b) => a.marketPrice - b.marketPrice);
      const resultRuleData = helper.mergeSameRuleDish(dishList, dishTypeList);

      // 标签中类与原生中类合并
      const dishTypeListWithTag = getDishTypesWithTag(resultRuleData.dishList);
      const mergedDishTypeList = dishTypeListWithTag.concat(resultRuleData.dishTypeList);
      const updatingObj = {
        dishesDataDuplicate: resultRuleData.dishList,
        dishTypesData: mergedDishTypeList,
        menuDataStatus: true, // 数据请求完毕
        dishesData: [],
        activeDishTypeId: dishTypeListWithTag[0] ? dishTypeListWithTag[0].id : getFirstValidDishTypeId(payload),
        normalDiscountProps: payload.discountInfo,
      };

      return state.setIn(['shopInfo', 'formatDishesData'], helper.formatDishesData(dishList)).merge(updatingObj);
    }
    case 'ACTIVE_DISH_TYPE':
      return state.setIn(['activeDishTypeId'], payload.dishTypeId).setIn(['activeDishTypeIdIndex'], payload.dishTypeIdIndex);
    case 'TOGGLE_DISH_DETAIL':
      return state.setIn(['dishDetailData'], payload);
    case 'SET_DATA_INIT_OVER':
      return state.setIn(['isDataInitOver'], payload);
    case 'TOGGLE_DISH_DESC':
      return state.setIn(['dishDescData'], payload);
    case 'SET_SOLD_DISH_LIST': {
      const formatRecommentList = list =>
        list.map(item => ({
          dishId: item.id,
          soldNum: item.soldNum,
        }));

      if (payload.dishMenuRecommendList) {
        return state.set('soldTopDishList', formatRecommentList(payload.dishMenuRecommendList));
      } else if (payload.dishDetailRecommendList) {
        return state.set('dishDetailRecommendDishList', payload.dishDetailRecommendList);
      }
      return state;
    }
    case 'SET_GUID_STATUS':
      return state.set('guidStatus', payload);
    /*
    case 'SET_COUPON_STATUS':
      return state.set('couponStatus', payload);
    */
    case 'REMOVE_ALL_ORDERS':
      return state.update('dishesDataDuplicate', dishes => dishes.flatMap(dish => dish.set('order', undefined)));
    case 'REINSTATE_UNDEFINED':
      return state.set('saveOrderChangeItem', null);
    case 'CLEAR_SAVE_ORDER':
      return state.set('saveOrderChangeItem', 'clearAll');
    case 'SET_TAKEAWAY_SERVICE_PROPS':
      return state.set('takeawayServiceProps', payload);
    case 'BATCH_ORDER_DISH': { // 再来一单批量设置order
      const { dishList: anthorDishList = [], changed } = payload;
      let _newState = state; // 为了和外部newState区别
      _newState = _newState.set('changed', changed);
      anthorDishList.forEach((dish = {}) => {
        const dishIdx = _findIndex(state.dishesDataDuplicate, { id: String(dish.id) });
        if (helper.isSingleDishWithoutProps(dish)) { // 简单菜
          const { order } = dish;
          const count = typeof order === 'number'
                        ? order
                        : order.reduce((all, cur) => all + cur.count, 0);
          _newState = _newState.setIn(['dishesDataDuplicate', dishIdx, 'order'], count);
        } else { // 套餐、多规格
          const dishAllDishList = _newState.dishesDataDuplicate.filter(d => d.id === dish.id);
          if (!dishAllDishList.length) return;
          const [dishAllDish] = dishAllDishList;
          if (dishAllDish.groups && dishAllDish.groups.length) { // 套餐
            const { order } = dish;
            _newState = _newState.setIn(['dishesDataDuplicate', dishIdx, 'order'], order);
          } else { // 多规格菜品
            const { order: oriOrder } = dishAllDish;
            const newOrder = helper.getAnthorOrder(dish);
            const allOrder = oriOrder ? oriOrder.concat(newOrder) : newOrder;
            _newState = _newState.setIn(['dishesDataDuplicate', dishIdx, 'order'], allOrder);
          }
        }
      });
      return _newState;
    }
    case 'ORDER_DISH': {
      const [dish] = payload;
      const dishIdx = _findIndex(state.dishesDataDuplicate, { id: String(dish.id) });

      if (helper.isSingleDishWithoutProps(state.dishesDataDuplicate[dishIdx])) {
        // for single dish without props;
        newState = state.setIn(['dishesDataDuplicate', dishIdx, 'order'], helper.getNewCountOfDish(state.dishesDataDuplicate[dishIdx], payload[1], dish));
      } else {
        // for single dish with props
        const currentOrder = state.dishesDataDuplicate[dishIdx].order || [];
        const [firstNextOrder] = dish.order;

        if (helper.isGroupDish(state.dishesDataDuplicate[dishIdx])) {
          orderIdx = _findIndex(currentOrder, { groups: firstNextOrder.groups });
        } else {
          orderIdx = _findIndex(currentOrder, {
            dishIngredientInfos: firstNextOrder.dishIngredientInfos,
            dishPropertyTypeInfos: firstNextOrder.dishPropertyTypeInfos,
          });
        }

        if (orderIdx !== -1) {
          // if find the order with same props, just add the count of the exsited order;
          newState = state.setIn(
            ['dishesDataDuplicate', dishIdx, 'order', orderIdx, 'count'],
            Math.min(state.dishesDataDuplicate[dishIdx].order[orderIdx].count + firstNextOrder.count, MaxOrderedDishCount),
          );

          if (newState.dishesDataDuplicate[dishIdx].order[orderIdx].count < dish.dishIncreaseUnit) {
            // if order's count is 0, remove it.
            newState = newState.updateIn(['dishesDataDuplicate', dishIdx, 'order'], order =>
              order.flatMap((eachOrder, idx) => (orderIdx === idx ? [] : eachOrder)),
            );
          }
        } else {
          // if cannot find the order with same props,add it as new order;
          newState = state.updateIn(['dishesDataDuplicate', dishIdx, 'order'], order => (order === undefined ? dish.order : order.concat(dish.order)));
        }
      }

      return newState.setIn(['dishesDataDuplicate', dishIdx, 'dishTypeName'], dish.dishTypeName || '默认分类');
    }
    case 'CHANGE_DISH':
      return state.set('saveOrderChangeItem', payload);
    case 'SET_DISCOUNT_TO_ORDER': {
      const discountData =
        (payload.dishList && payload.dishList.length) || payload.type === MemberPrivTypes.UNIFIED_DISCOUNT
          ? payload
          : state.normalDiscountProps || {};
      const {
        isMember = false,
        dishList = [],
        type: discountType = 1,
        levelName = '',
        loginType = 1,
        isPeriod,
        discount = 1,
        ableAddPriceDiscount = false,
      } = discountData;
      const uniqDishList = helper.uniqueDiscountInfo(isPeriod ? dishList : []);
      const isUserMember = payload.isMember === true;
      helper.storeDishesLocalStorage(state.dishesDataDuplicate, state.shopInfo);
      // const orderId = helper.getUrlParam('orderId');
      const orderId = sessionStorage.orderId;
      return state.set('discountProps', payload).update('dishesDataDuplicate', dishesData =>
          dishesData.flatMap(dishData => {
          let memberPrice = null;
          if (discountType === MemberPrivTypes.UNIFIED_DISCOUNT) {
            memberPrice = discount;
          } else {
            const discountInfo = uniqDishList.find(item => item.dishId === dishData.id);
            memberPrice = discountInfo ? discountInfo.value : memberPrice;
          }

          const memberPriceStr = (memberPrice !== null && memberPrice !== undefined) ? memberPrice.toString() : null;  // 消除memberPrice为0的影响

          // 是会员，并且有会员折扣，计算口味做法相关价格
          let { dishPropertyTypeInfos, dishIngredientInfos, groups } = dishData;
          if (isUserMember && memberPriceStr && ableAddPriceDiscount) {
            const res = helper.computePropsAndIngredientMemberRePrice(dishData, memberPrice, discountType);
            dishPropertyTypeInfos = res.dishPropertyTypeInfos;
            dishIngredientInfos = res.dishIngredientInfos;

            if (Array.isArray(groups)) {
              groups = helper.computeMemberRePriceByGroups(groups, memberPrice, discountType);
            }
          }
          // 处理再来一单order的会员价
          let order = dishData.order;
          if (order) {
            if (memberPriceStr) {
              if (Array.isArray(groups)) {
                order = helper.computeGroupOrderMemberPrice(dishData, memberPrice, discountType, ableAddPriceDiscount);
              } else {
                order = helper.computeOrderMemberPrice(dishData, memberPrice, discountType, ableAddPriceDiscount);
              }
            }
          }
          if (orderId) {
            return dishData
            // .set('isMember', !!memberPrice)
            // .set('memberPrice', memberPrice || false)
            .set('isMember', !!memberPriceStr)
            .set('memberPrice', memberPriceStr ? memberPrice : false)
            .set('discountType', discountType)
            .set('discountLevel', levelName)
            .set('loginType', loginType)
            .set('isUserMember', isUserMember)
            .set('dishPropertyTypeInfos', dishPropertyTypeInfos, { deep: true })
            .set('dishIngredientInfos', dishIngredientInfos, { deep: true })
            .set('groups', groups, { deep: true })
            .set('order', order);
          } else {
            return dishData
              // .set('isMember', !!memberPrice)
              // .set('memberPrice', memberPrice || false)
              .set('isMember', !!memberPriceStr)
              .set('memberPrice', memberPriceStr ? memberPrice : false)
              .set('discountType', discountType)
              .set('discountLevel', levelName)
              .set('loginType', loginType)
              .set('isUserMember', isUserMember)
              .set('dishPropertyTypeInfos', dishPropertyTypeInfos, { deep: true })
              .set('dishIngredientInfos', dishIngredientInfos, { deep: true })
              .set('groups', groups, { deep: true });
          }
        })
      );
    }
    case 'SET_NORMAL_DISCOUNT': {
      const urlType = commonHelper.getUrlParam('type');
      let commercialNotice = '';
      switch (urlType) {
        case 'TS':
          commercialNotice = payload.commercialNoticeTS || '';
          break;
        case 'WM':
          commercialNotice = payload.commercialNoticeWM || '';
          break;
        default:
          break;
      }

      return state
        .set('normalDiscountProps', payload.discountInfo)
        .setIn(['shopInfo', 'marketList'], helper.formatMarket(payload.marketing || [], state.shopInfo.formatDishesData))
        .setIn(['shopInfo', 'marketListUpdate'], helper.formatMarketUpdate(payload.marketing || [], state.shopInfo.formatDishesData))
        .setIn(
          ['shopInfo', 'marketMatchDishes'],
          helper.matchDishesData(helper.formatMarketUpdate(payload.marketing || [], state.shopInfo.formatDishesData), state.shopInfo.formatDishesData),
        )
        .setIn(['shopInfo', 'multiMarketing'], payload.multiMarketing)
        .setIn(['shopInfo', 'limitedMarketing'], payload.limitedMarketing)
        .setIn(['shopInfo', 'notice'], filterNoneString('word', commercialNotice))
        .setIn(['shopInfo', 'getMarket'], true);
    }
    case 'SET_ERROR_MSG': {
      let newPayload = {};
      if (typeof payload === 'string') {
        newPayload.text = payload;
      } else {
        newPayload = payload;
      }
      return state.set('errorMessage', newPayload || {});
    }
    case 'SET_COUPON_SUCCESS_INFO':
      return state.setIn(['shopInfo', 'couponSuccessInfo'], payload || {});
    case 'SET_COUPON_SUCCESS':
      return state.setIn(['shopInfo', 'couponSuccess'], payload);
    case 'SET_LOAD_MSG':
      return state.set('load', payload);
    case 'SET_TABLE_AREA_INFO':
      return state.set('tableAreaInfo', payload);
    case 'SET_SHOP_ORDER_STATUS':
      return state.set('isAcceptOrder', payload);
    case 'SET_SHOP_INFO': {
      const isWM = helper.getUrlParam('type') === 'WM';
      const updateShopInfo = {
        dishPageTpl: isWM ? payload.dishPageTpl : payload.tsDishPageTpl,
        enableMemberRegistry: payload.enableMemberRegistry,
        dishBoxChargeInfo: isWM && payload.extraCharge ? payload.extraCharge : null,
        isAcceptTakeaway: payload.isAcceptTakeaway,
        isHDL: payload.isHDL,
        guide: payload.guide,
        operateImgUrl: filterNoneString('url', isWM ? payload.operateImgUrl : payload.tsOperateImgUrl),
        operateUrl: filterNoneString('url', isWM ? payload.operateUrl : payload.tsOperateUrl),
        swiperAdImgs: isWM ? payload.marketImgsWm : payload.marketImgsTs,
        shopLogo: payload.shopLogo,
        orderPageImage: filterNoneString('url', payload.orderPageImage),
        tsOperateUrl: filterNoneString('url', payload.tsOperateUrl),
        tsOperateImgUrl: filterNoneString('url', payload.tsOperateImgUrl),
        fullAdvertUrl: filterNoneString('url', payload.fullAdvertUrl),
        fullAdvertImgUrl: filterNoneString('url', payload.fullAdvertImgUrl),
        showFullscreenAd: payload.showFullscreenAd,
        orderPageTitle: filterNoneString('word', isWM ? payload.orderPageTitle : payload.tsOrderPageTitle),
        wmCartImageUrl: filterNoneString('url', payload.wmCartImageUrl),
        tsCartImageUrl: filterNoneString('url', payload.tsCartImageUrl),
        enableSyncShoppingCart: payload.enableSyncShoppingCart,
        sendTimeList: payload.sendTimeList,
        openTimeList: payload.openTimeList,
        loadShopStatus: true,
        shopInfo: {
          isOldMarketing: payload.isOldMarketing,
          commercialName: payload.commercialName,
          openTimeList: payload.openTimeList,
          diningForm: payload.diningForm, // 0 正餐 1 快餐
          isSingleShop: payload.isSingleShop,
          marketCoupon: payload.takeCouponVO || {},
          formatDishesData: {},
          marketList: {},
          marketListUpdate: [],
          marketMatchDishes: false,
          mobile: payload.mobile,
          serviceMobile: payload.serviceMobile,
          nationTelCode: payload.nationTelCode,
          address: payload.address,
          multiMarketing: [],
          limitedMarketing:[],
          notice: null,
          couponSuccessInfo: null,
          couponSuccess: false,
          isEnableShop: isWM ? payload.isEnableWm : payload.isEnableTs,
          choosePeopleCountFlag: payload.choosePeopleCountFlag,
          serviceSupply: payload.ringVOS,
          openStatus: payload.openStatus,
          isYaZuo: payload.isYaZuo || false,
          goodsNumEditable: payload.goodsNumEditable || false,
          couponList: payload.takeCouponVOS || [],
          ruleId: payload.ruleId,
          planId: payload.planId,
          flag: payload.flag,
          type: payload.type,
          payBeforeDinner: payload.payBeforeDinner,
          isToHomeFlag: payload.isToHomeFlag,
          isToShopFlag: payload.isToShopFlag,
          enableWeixinMini: payload.enableWeixinMini,
          enableOpenDish: payload.enableOpenDish === 1,
          isAcceptTakeaway: payload.isAcceptTakeaway,
          avaliableDays: payload.avaliableDays,
        },
      };
      return state.merge(updateShopInfo);
    }

    case 'SET_PAGE_LOADED_STATUS':
      return state.set('pageIsLoaded', payload);

    case 'SET_SERVICE_STATUS':
      return state.set('serviceStatus', payload || {});

    case 'SET_CALL_MSG': {
      return state.set('callMsg', payload || {});
    }
    case 'SET_CANCEL_CALL_MSG': {
      return state.set('callMsg', payload || {});
    }
    case 'SET_CAN_CALL': {
      return state.set('callAble', payload);
    }
    case 'SET_DELIVERY_TIME': {
      return state.set('deliveryTime', payload);
    }
    case 'SET_MUST_ORDER_DISH_LIST': {
      const { selfChooseDishList, selfChooseDishTypeObj } = payload || {};
      return state.set('selfChooseDishList', selfChooseDishList)
                  .set('selfChooseDishTypeObj', selfChooseDishTypeObj);
    }

    default:
      return state;
  }
};

reducerContainer.add('UPDATE_DISH_ORDER', (state, payload) => {
  const dishList = payload;
  if (!dishList || !dishList.length) {
    return state;
  }

  return state.update('dishesDataDuplicate', dishes =>
    dishes.flatMap(dish => {
      const orderedDish = dishList.filter(item => String(item.id) === dish.id)[0];
      if (!orderedDish) {
        return dish;
      }

      return dish.set('order', orderedDish.order);
    }),
  );
});



// WEBPACK FOOTER //
// ./src/reducer/dish-menu/index.js